import { DeviceTaskType } from "./IDevice";

export interface IDeviceTask {
    get TaskType(): DeviceTaskType;

    get Guid(): string;

    get DeviceGuid(): string;

    get Channel(): number;
}

export enum DeviceControlFeature {
    TurnOn = 0,
    TurnOff = 1,
    ToggleState = 2,
    SetBlindPosition = 3,
    SetLightColor = 4,
    SetLightTemperature = 5,
    SetLightBrightness = 6,
    SetTemperature = 7,
    GetState = 8,
    TurnOnWithTimeout = 9,
    SetLightBrightnessDynamicly = 10,
    IdentifyDevice = 11,
    SetBlindOpenCloseTime = 12,
    SetBlindMicroventilation = 13,
    //SetGatePosition = 14,
    //OpenGate = 15,
    //CloseGate = 16,
    //SetGatePositionPercentage = 17,
    //GateOn = 18,
    //GateOff = 19,
    //OpenGateway = 20,
    //CloseGateway = 21,
    //SetGatewayPositionPercentage = 22,
    //GatewayOn = 23,
    //GatewayOff = 24,
    GatewayPulse = 25,
    GatePulse = 26,
    //SetFacadePosition = 27,
    //SetFacadeTilt = 28,
    SetFacadePositionAndTilt = 29,
    GetFacadeType = 30,
    LightRGBW = 31,
    SetGatePositionPrecise = 32,
    SetGatePositionPreciseSecure = 33,
}